import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { UtilsService } from '../services/utils.service';

@Component({
  selector: 'app-update-app-modal',
  templateUrl: './update-app-modal.component.html',
  styleUrls: ['./update-app-modal.component.scss', './update-app-modal.component.rtl.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class UpdateAppModalComponent implements OnInit {
  @Input() updatedStaus: boolean = true;
  constructor(private swUpdate: SwUpdate, private utilService: UtilsService) {

  }

  updateNeeded: boolean = false
  ngOnInit(): void { 
    this.utilService.updatedStatus$.subscribe(status => {
      this.updateNeeded = status;
    });
  }

  onRefreshClick() {
    if(this.updatedStaus){
      this.swUpdate.activateUpdate().then(() => window.location.reload());
    } else if(this.updateNeeded){
      this.utilService.setUpdatedStatus(false)
      window.location.reload()
    }
  }
}
